/* Theme V2 — Creative Layouts gallery (templates/page.creative-layout-gallery.liquid; styles assets/v2-creative.css).
   - Collection pills filter the cards and keep ?category=<url_category_parameter> in the address bar.
   - Filters (size, frame, photos; built from the templates' tags) in the left column, or in a sheet under 990px.
     A template is in every photo range one of its layouts is in (data-photos="|1-3|4-9|"). Options with no template
     in the chosen collection are hidden (unless ticked). Cards keep the order Liquid rendered (the position field).
   - A card opens the template panel (a <dialog>): its image loads only then. "Customize in editor" opens
     https://editor.socialprintstudio.com/products/<product>/order?values=defaultLayout:<id>,filter:<ids> (the old site's link;
     size:<size> is added only for a generic product id with no size in it) in a new tab and sends editor_link_clicked (docs/posthog.md), as the Flat Card gallery does.
   Cards are rendered by Liquid with lazy images, so a hidden card (another collection, filtered out) never loads. */
(function () {
  var root = document.querySelector('[data-v2cl]');
  if (!root) return;
  var grid = root.querySelector('[data-v2cl-grid]');
  if (!grid) return;
  var items = Array.prototype.slice.call(grid.querySelectorAll('[data-v2cl-item]'));
  var pills = Array.prototype.slice.call(root.querySelectorAll('[data-v2cl-cat]'));
  var countEl = root.querySelector('[data-v2cl-count]');
  var noneEl = root.querySelector('[data-v2cl-none]');
  var sheet = root.querySelector('[data-v2cl-sheet]');
  var panel = root.querySelector('[data-v2cl-panel]');
  var activeBadge = root.querySelector('[data-v2cl-active-count]');
  var showBtn = root.querySelector('[data-v2cl-show]');
  var SIZES = ['8x8', '8x10', '8x12', '10x10', '10x30', '11x14', '12x12', '12x18', '12x36', '16x16', '16x20', '16x24', '20x20', '20x30', '20x40', '24x24', '24x36', '30x30', '30x40', '30x45'];

  var state = { cat: '', sizes: [], frames: [], photos: [] };
  var ATTR = { sizes: 'data-sizes', frames: 'data-frames', photos: 'data-photos' };

  function track(event, props) {
    try { if (window.SPSPostHog && window.SPSPostHog.capture) window.SPSPostHog.capture(event, props); } catch (e) {}
  }

  /* ---------- filtering ---------- */
  function has(li, key, value) { return (li.getAttribute(ATTR[key]) || '').indexOf('|' + value + '|') > -1; }
  function inCat(li) { return !state.cat || (li.getAttribute('data-cats') || '').indexOf('|' + state.cat + '|') > -1; }
  function matches(li) {
    if (!inCat(li)) return false;
    return ['sizes', 'frames', 'photos'].every(function (key) {
      return !state[key].length || state[key].some(function (v) { return has(li, key, v); });
    });
  }
  // hide the filter options no template in the chosen collection has (a ticked one stays, so it can be unticked)
  function syncOptions() {
    var inView = items.filter(inCat);
    root.querySelectorAll('[data-v2cl-filter]').forEach(function (input) {
      var key = input.getAttribute('data-v2cl-filter');
      var label = input.closest('label');
      if (!label || !ATTR[key]) return;
      var any = input.checked || inView.some(function (li) { return has(li, key, input.value); });
      label.hidden = !any;
    });
    root.querySelectorAll('.v2-cl-f').forEach(function (group) {
      group.hidden = !group.querySelector('label:not([hidden])');
    });
  }
  function render() {
    var n = 0;
    items.forEach(function (li) { var ok = matches(li); li.hidden = !ok; if (ok) n++; });
    if (countEl) countEl.textContent = n + (n === 1 ? ' template' : ' templates');
    if (noneEl) noneEl.hidden = n > 0;
    if (showBtn) showBtn.textContent = n === 1 ? 'Show 1 template' : 'Show ' + n + ' templates';
    var active = state.sizes.length + state.frames.length + state.photos.length;
    if (activeBadge) { activeBadge.hidden = !active; activeBadge.textContent = active; }
    pills.forEach(function (p) {
      var on = (p.getAttribute('data-v2cl-cat') || '') === state.cat;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    syncOptions();
    var preset = document.getElementById('v2cl-preset');
    if (preset) preset.parentNode.removeChild(preset);
  }

  function setCat(cat, push) {
    state.cat = cat || '';
    render();
    if (push) {
      try {
        var url = new URL(window.location.href);
        if (state.cat) url.searchParams.set('category', state.cat); else url.searchParams.delete('category');
        history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      } catch (e) {}
    }
  }

  // ?category= on arrival: only a collection that has templates
  try {
    var wanted = new URLSearchParams(window.location.search).get('category') || '';
    var known = pills.some(function (p) { return wanted && p.getAttribute('data-v2cl-cat') === wanted; });
    state.cat = known ? wanted : '';
  } catch (e) {}

  pills.forEach(function (p) {
    p.addEventListener('click', function () {
      setCat(p.getAttribute('data-v2cl-cat') || '', true);
      if (p.scrollIntoView && window.matchMedia('(max-width: 989px)').matches) p.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
  });

  // filters: two copies (left column, sheet) kept in step
  root.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-v2cl-filter]')) return;
    var key = input.getAttribute('data-v2cl-filter');
    var list = state[key];
    var i = list.indexOf(input.value);
    if (input.checked && i === -1) list.push(input.value);
    if (!input.checked && i > -1) list.splice(i, 1);
    root.querySelectorAll('[data-v2cl-filter="' + key + '"][value="' + input.value.replace(/"/g, '') + '"]').forEach(function (x) { x.checked = input.checked; });
    render();
  });
  root.querySelectorAll('[data-v2cl-clear]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.sizes = []; state.frames = []; state.photos = [];
      root.querySelectorAll('[data-v2cl-filter]').forEach(function (x) { x.checked = false; });
      render();
    });
  });

  /* ---------- dialogs ---------- */
  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open');
  }
  [sheet, panel].forEach(function (d) {
    if (!d) return;
    d.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      var v = d.querySelector('video'); if (v) v.pause();
    });
    d.addEventListener('click', function (e) { if (e.target === d) closeDialog(d); });
    d.querySelectorAll('[data-v2cl-close]').forEach(function (b) { b.addEventListener('click', function () { closeDialog(d); }); });
  });
  var sheetOpen = root.querySelector('[data-v2cl-sheet-open]');
  if (sheetOpen) sheetOpen.addEventListener('click', function () { openDialog(sheet); });

  /* ---------- the template panel ---------- */
  var current = null;
  var pImg = panel && panel.querySelector('[data-v2cl-panel-img]');
  var pVideo = panel && panel.querySelector('[data-v2cl-panel-video]');
  var pTitle = panel && panel.querySelector('[data-v2cl-panel-title]');
  var pEyebrow = panel && panel.querySelector('[data-v2cl-panel-eyebrow]');
  var pDesc = panel && panel.querySelector('[data-v2cl-panel-desc]');
  var pSizes = panel && panel.querySelector('[data-v2cl-panel-sizes]');
  var pPrice = panel && panel.querySelector('[data-v2cl-panel-price]');
  var pGo = panel && panel.querySelector('[data-v2cl-go]');

  function sizesOf(li) {
    var own = (li.getAttribute('data-sizes') || '').split('|').filter(Boolean);
    return own.length ? own : SIZES;
  }
  function chosenSize() {
    var on = pSizes && pSizes.querySelector('[aria-checked="true"]');
    return on ? on.getAttribute('data-size') : '';
  }
  function openPanel(li) {
    if (!panel) return;
    current = li;
    var card = li.querySelector('.v2-cl-card');
    var title = li.getAttribute('data-title') || '';
    var layouts = +li.getAttribute('data-layouts') || 1;
    var coll = li.getAttribute('data-collection') || '';
    pTitle.textContent = title;
    pEyebrow.textContent = [coll, layouts > 1 ? layouts + ' layouts' : ''].filter(Boolean).join(' · ');
    var desc = card && card.querySelector('.v2-cl-card__desc');
    pDesc.innerHTML = desc ? desc.innerHTML : '';
    pDesc.hidden = !pDesc.textContent.trim();
    var full = li.getAttribute('data-full') || '';
    var thumb = card && card.querySelector('img');
    pImg.src = full || (thumb ? thumb.currentSrc || thumb.src : '');
    pImg.alt = title;
    // a pop-up video (from Prismic) plays in place of the photo, muted and looping, with the photo as its poster
    var video = li.getAttribute('data-video') || '';
    if (pVideo) {
      pVideo.pause();
      if (video && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        pVideo.poster = pImg.src;
        if (pVideo.getAttribute('src') !== video) pVideo.setAttribute('src', video);
        pVideo.setAttribute('aria-label', title);
        pVideo.hidden = false; pImg.hidden = true;
        var pr = pVideo.play(); if (pr && pr.catch) pr.catch(function () {});
      } else {
        pVideo.hidden = true; pImg.hidden = false;
      }
    }
    var sizes = sizesOf(li);
    var first = (li.getAttribute('data-sizes') || '').split('|').filter(Boolean)[0] || '';
    var pick = state.sizes.filter(function (s) { return sizes.indexOf(s) > -1; })[0] || first || sizes[0];
    pSizes.innerHTML = '';
    sizes.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'v2-cl-chip';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-size', s);
      b.setAttribute('aria-checked', s === pick ? 'true' : 'false');
      b.textContent = s.replace('x', ' × ') + ' in';
      pSizes.appendChild(b);
    });
    var price = card && card.querySelector('.v2-cl-card__price');
    pPrice.textContent = price ? price.textContent : (pPrice.getAttribute('data-from') || '');
    openDialog(panel);
  }
  if (pSizes) pSizes.addEventListener('click', function (e) {
    var b = e.target.closest('[data-size]');
    if (!b) return;
    pSizes.querySelectorAll('[data-size]').forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
  });

  grid.addEventListener('click', function (e) {
    var a = e.target.closest('[data-v2cl-open]');
    if (!a) return;
    // a plain click opens the panel; cmd/ctrl/middle-click keeps the link to the editor
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    openPanel(a.closest('[data-v2cl-item]'));
  });

  if (pGo) pGo.addEventListener('click', function () {
    if (!current) return;
    var product = current.getAttribute('data-product') || 'print';
    var id = current.getAttribute('data-template-id') || '';
    var size = chosenSize();
    // the old site's link: defaultLayout + filter; the product id already names the size (print-11x14)
    var withSize = size && !/\d+x\d+$/.test(product);
    var values = 'defaultLayout:' + id + (withSize ? ',size:' + size : '') + ',filter:' + (current.getAttribute('data-filter') || id);
    var base = 'https://editor.socialprintstudio.com/products/' + encodeURIComponent(product) + '/order';
    // editor_link_clicked (docs/posthog.md): sps-posthog.js counts editor links (<a href>); this button opens the
    // editor with window.open, so it reports the hand-off itself.
    track('editor_link_clicked', {
      destination_host: 'editor.socialprintstudio.com',
      destination_path: '/products/' + product + '/order',
      link_text: 'Customize in editor',
      link_area: 'creative-layout-gallery',
      from_product_cta: false,
      template_title: current.getAttribute('data-title') || null,
      default_layout: id || null,
      size: size || null,
      collection: state.cat || null,
    });
    window.open(base + '?values=' + encodeURIComponent(values), '_blank');
  });

  render();

  // a ?category= link: the green pill is the only sign of the chosen collection, so bring it into the pill row's view
  // (the row scrolls sideways under 990px); only the row scrolls, never the page
  if (state.cat) {
    var activePill = root.querySelector('.v2-cpills__pill.is-active');
    var row = activePill && activePill.closest('.v2-cpills');
    if (row && row.scrollWidth > row.clientWidth) {
      var pr = activePill.getBoundingClientRect(), rr = row.getBoundingClientRect();
      row.scrollLeft = Math.max(0, row.scrollLeft + (pr.left - rr.left) - (rr.width - pr.width) / 2);
    }
  }
})();
